import React, { Component } from 'react';
import Section from '../layout/Section';
import ImageText from '../subcomponents/ImageText';
import SectionContainer from '../subcomponents/SectionContainer';
import meet from '../assets/img/background/meet.jpg';
import banner from '../assets/img/vector/nosotros.svg';
import nosotros from '../assets/img/vector/nosotros2.svg';
import IconBlock28 from '../subcomponents/IconBlock28';
import TextImage from '../subcomponents/TextImage';
import nosotros1 from '../assets/img/flat/nosotros1.svg';
import nosotros2 from '../assets/img/flat/nosotros2.svg';
import nosotros3 from '../assets/img/flat/nosotros3.svg';

class Nosotros extends Component {
  componentDidMount() {
    document.title = 'Nosotros - Insacom';
    /* eslint-disable */
    $.HSCore.components.HSCarousel.init('.js-carousel');
  }

  render() {
    const partners = [
      { title: 'Debian', img: require('../assets/img/partners/debian.png') },
      { title: 'Supermicro', img: require('../assets/img/partners/supermicro.png') },
      { title: 'Acronis', img: require('../assets/img/partners/acronis.png') },
      { title: 'Cisco', img: require('../assets/img/partners/cisco.png') },
      { title: 'Fortinet', img: require('../assets/img/partners/fortinet.png') },
      { title: 'Mikrotik', img: require('../assets/img/partners/mikrotik.png') },
      { title: 'Ubiquiti', img: require('../assets/img/partners/ubiquiti.png') },
      { title: 'Hikvision', img: require('../assets/img/partners/hikvision.png') }
    ];

    let iconBlocks = [
      {
        id: 1,
        title: 'Innovación',
        description:
          'Constantemente invertimos en I+D para ofrecer soluciones con tecnología pionera',
        img: nosotros1
      },
      {
        id: 2,
        title: 'Ingenieros Capacitados',
        description:
          'Nuestros ingenieros están altamente capacitados para resolver problemáticas de alta complejidad',
        img: nosotros2
      },
      {
        id: 3,
        title: 'Código Abierto',
        description: 'Utilizamos y contribuimos fuertemente a los proyecto de código abierto',
        img: nosotros3
      }
    ];

    return (
      <Section no-contact>
        <SectionContainer grey paddingTop={100} paddingBottom={'0px'}>
          <ImageText
            image={banner}
            title="Nosotros"
            description="Somos una empresa orientada a dar soluciones informáticas y de telecomunicaciones de alto nivel en el ámbito empresarial."></ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock28 version={1} content={iconBlocks}></IconBlock28>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={banner}
            title="Nuestra Empresa"
            description="Con más de 10 años en los mercados de TI y Telecomunicaciones nos hemos posicionado con una cartera de clientes que van desde grandes corporaciones hasta pequeñas pymes en diversos rubros. El trato cercano y la flexibilidad de nuestras soluciones nos han permitido mantener un crecimiento sostenido durante estos años. ">
            <p>
              Ofrecemos soluciones para las distintas necesidades de Infraestructura de Red,
              Telecomunicaciones, Desarrollo de Software, Data Center, Sistemas de Vigilancia y
              Servicios TI.
            </p>
            <p>
              Contamos con una robusta infraestructura con altos estándares de calidad y servicio,
              lo que nos permite crear un puente de comunicación y confianza con nuestros clientes.
            </p>
          </TextImage>
        </SectionContainer>
        <SectionContainer>
          <ImageText
            image={nosotros}
            title="I+D"
            description="La innovación es uno de nuestros pilares fundamentales, es por eso que constantemente estamos desarrollando laboratorios probando las últimas tecnologías, para luego incorporarlas a nuestros servicios y productos usando lo mejor de nuestra I+D."></ImageText>
        </SectionContainer>
        <div
          className="g-bg-img-hero g-bg-size-cover"
          style={{ background: `url(${meet})`, backgroundPosition: 'center 0' }}>
          <section className="clearfix g-px-15 g-py-50">
            <div className="g-max-width-600 text-center mx-auto pt-5">
              <h2 className="g-color-gray-dark-v1 g-font-weight-600 g-font-size-30 mb-4">
                Nuestros <span className="g-color-primary g-font-size-35">Partners</span>
              </h2>
            </div>
            <div className="container" style={{ maxWidth: 1500 }}>
              <div
                className="js-carousel g-pb-45"
                data-autoplay="true"
                data-infinite="true"
                data-slides-show="4"
                data-slides-scroll="2"
                data-pagi-classes="u-carousel-indicators-v1 g-absolute-centered--x text-center g-bottom-20"
                data-responsive='[{
                            "breakpoint": 1200,
                            "settings": {
                            "slidesToShow": 4
                            }
                        }, {
                            "breakpoint": 992,
                            "settings": {
                            "slidesToShow": 3
                            }
                        }, {
                            "breakpoint": 768,
                            "settings": {
                            "slidesToShow": 2
                            }
                        }, {
                            "breakpoint": 576,
                            "settings": {
                            "slidesToShow": 1
                            }
                        }]'>
                {partners &&
                  partners.map((item, key) => (
                    <div key={key} className="js-slide g-brd-gray-light-v4 rounded g-pa-20 g-mx-10">
                      <img className="img-fluid mx-auto" src={item.img} alt={item.title} />
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </Section>
    );
  }
}

export default Nosotros;



// WEBPACK FOOTER //
// ./src/sections/Nosotros.js